import Button from '../../../juristec-ui/core/Button';
import IconButton from '../../../juristec-ui/core/IconButton';
import { Close } from '../../../juristec-ui/icons';
import {
  InfoBannerContainer, MessageContainer,
} from './styled';

interface PublicInfoBannerProps {
  dashPath: string;
  close: () => void;
}

const PublicInfoBanner = ({
  dashPath, close,
}: PublicInfoBannerProps) => {
  const goToOriginalDashboard = () => {
    window.open(new URL(dashPath, window.location.href), '_blank');
  };

  return (
    <InfoBannerContainer>
      <MessageContainer>
        <p>
          O dashboard público é uma cópia estática do dashboard original. Subtabelas,
          subgráficos e filtros globais estão disponíveis apenas para usuários autenticados.
        </p>
        <div>
          <Button
            onClick={goToOriginalDashboard}
            color="info"
            size="small"
            textTransform="none"
          >
            Clique aqui
          </Button>
          <span>para fazer login no sistema.</span>
        </div>
      </MessageContainer>
      <IconButton
        onClick={close}
        shape="rounded"
        variant="pattern"
        size="small"
        className="close-btn"
        style={{ boxShadow: 'none' }}
      >
        <Close />
      </IconButton>
    </InfoBannerContainer>
  );
};

export default PublicInfoBanner;
